import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  Button,
  Box,
  Alert,
  CircularProgress,
  TextField,
} from "@mui/material";

import { AdminAuthService } from "../../services/AdminAuthService";
import { UserAuthService } from "../../services/UserAuthService";
import { AuthLayout } from "../../components/AuthLayout";

export const LoginPage: React.FC = () => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const trimmedEmail = email.trim().toLowerCase();

    // Clear any stale tokens before attempting login
    localStorage.removeItem("admin_access_token");
    localStorage.removeItem("admin_refresh_token");
    localStorage.removeItem("admin_token_expires_at");
    localStorage.removeItem("user_access_token");
    localStorage.removeItem("user_refresh_token");
    localStorage.removeItem("user_token_expires_at");

    // Try admin login first
    try {
      const adminRes = await AdminAuthService.login(trimmedEmail, password, dispatch);
      if (adminRes) {
        window.location.href = "/dashboard";
        return;
      }
    } catch (err) {
      // Admin login failed, try dealer
    }

    // If admin fails, try dealer login
    try {
      const dealerRes = await UserAuthService.login(trimmedEmail, password, dispatch);
      if (dealerRes) {
        window.location.href = "/";
        return;
      }
    } catch (err) {
      // Dealer login also failed
    }

    setError("Invalid email or password. Please try again.");
    setLoading(false);
  };

  return (
    <AuthLayout title="Sign In">
      <form onSubmit={handleSubmit}>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
          <TextField
            id="email"
            label="Email Address"
            name="email"
            required
            fullWidth
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            id="password"
            label="Password"
            name="password"
            type="password"
            required
            fullWidth
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
          <Link
            to="/forgot-password"
            style={{ color: "#64748B", fontSize: "0.875rem", textDecoration: "none" }}
          >
            Forgot password?
          </Link>
        </Box>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="secondary"
          disabled={loading}
          sx={{
            mt: 2,
            py: 1.3,
            fontSize: "0.938rem",
            fontWeight: 600,
          }}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : "Sign In"}
        </Button>
      </form>
    </AuthLayout>
  );
};
